import React from "react";

import Hima360LogoSVG from "components/svg/Hima360LogoSVG";
import styled from "styled-components";

const LogoButton = styled.button`
  cursor: pointer;
  padding-left: 0.95rem;
`;
type Method = () => void;

type HomeButtonProps = {
  onClicked?: Method;
};

export const HomeButton: React.FC<HomeButtonProps> = (props) => {
  return (
    <LogoButton data-testid="scadaplusbutton" onClick={props.onClicked}>
      <Hima360LogoSVG width="122" height="39" />
    </LogoButton>
  );
};
